import { defineStyleConfig } from "@chakra-ui/react";

export const IconSizes = {
  xs: {
    width: "12px",
    height: "12px",
  },
  sm: {
    width: "14px",
    height: "14px",
  },
  md: {
    width: "16px",
    height: "16px",
  },
  lg: {
    width: "18px",
    height: "18px",
  },
  xl: {
    width: "20px",
    height: "20px",
  },
  "2xl": {
    width: "24px",
    height: "24px",
  },
};

export type IconSizesType = keyof typeof IconSizes;

export const IconTheme = defineStyleConfig({
  defaultProps: {
    size: "md",
  },
  sizes: IconSizes,
});
